import dynamic from 'next/dynamic';

import { Textarea } from '@playbooks/ui/components/textarea';

export const TextEditorBasic = dynamic(() => import('@playbooks/wrappers/text-editor').then(v => v.TextEditorBasic), {
	ssr: false,
	loading: () => <Textarea onChange={() => null} />,
});
